import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import Iconify from '../../../components/Iconify';
import RefreshIcon from '@mui/icons-material/Refresh';


const TableSidebarActions = ({ actions, isSaveView, refreshTableContent }) => <Box>
  {/* Save view button - shouldnt it be passed as an action?*/}
  {/* {isSaveView && <Box
    sx={{ p: 3, width: '100%',
      display: 'flex',
      flexDirection: 'row' }}>
    <Button
      fullWidth
      variant="contained"
      endIcon={<Iconify icon={'eva:save-fill'} />}
      // TODO: add save view action
      onClick={() => window.alert('To implement')}
    >
          Zapisz widok
    </Button></Box>} */}

  {/* Custom actions buttons*/}
  {actions.map(action => !_.isNil(action.component) ? <action.component key={action.name} /> : <Box
    key = {action.name}
    sx={{ p: 3, width: '100%',
      display: 'flex',
      flexDirection: 'row' }}>
    <Button
      key = {action.name}
      fullWidth
      variant = "contained"
      endIcon = {action.icon}
      onClick = {action.onClick}
    > {action.text} </Button> </Box>
  )}

  <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
    <Button
      fullWidth
      variant="contained"
      endIcon={<RefreshIcon />}
      onClick={refreshTableContent}
    >
        Odśwież
    </Button>
  </Box>
</Box>;
TableSidebarActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.node,
    onClick: PropTypes.func.isRequired
  })),
  isGenerateRaport: PropTypes.bool,
  refreshTableContent: PropTypes.func.isRequired
};

TableSidebarActions.defaultProps = {
  isSaveView: true
};

export default TableSidebarActions;
